import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { selectSubMenu, setData } from '../../actions';
import { insertTask, updateTask } from '../general/api'; // Importa las nuevas funciones API
import './InsertTask.css';

const InsertTask = ({ navigationHistory, machine, taskType, isEdit, task }) => {
    const tomarDosPrimerasLetras = nombre => nombre.split(' ').map(palabra => palabra.substring(0, 2)).join('');
    const inicialesMaquina = tomarDosPrimerasLetras(machine.Name_Machine);
    const dispatch = useDispatch();
    if(task && task.length > 0 && task[0].Id_Task_Type && task[0].Id_Task_Type === '6'){
        isEdit = false;
    }

    const [formData, setFormData] = useState({
        id_task_type: '',
        internal_code: '',
        id_machine: '',
        interval: '',
        description: '',
        supplies: '',
        interval_unit: 'dias'
    });

    useEffect(() => {
        if (isEdit && task && task.length > 0) {
            setFormData({
                id_task_type: task[0].Id_Task_Type || '',
                internal_code: task[0].Internal_Code || '',
                id_machine: task[0].Id_Machine || '',
                interval: task[0].Interval || '',
                description: task[0].Description || '',
                supplies: task[0].Supplies || '',
                interval_unit: task[0].Interval_Unit || 'dias'
            });
        } else if (isEdit === false && task && task.length > 0) {
            setFormData({
                id_task_type: task[0].Id_Task_Type || '',
                internal_code: task[0].Internal_Code || '',
                id_machine: task[0].Id_Machine || '',
                interval: task[0].Interval || '',
                description: task[0].Description || '',
                supplies: task[0].Supplies || '',
                interval_unit: task[0].Interval_Unit || 'dias'
            });
        }
    }, [isEdit, task]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let intervalValue = formData.interval;
        if (formData.interval_unit === 'meses') {
            intervalValue = formData.interval * 30; // Convertir meses a días
        } else if (formData.interval_unit === 'años') {
            intervalValue = formData.interval * 365; // Convertir años a días
        }

        try {
            if (isEdit && task && task.length > 0) {
                await updateTask(task[0].Id_Task, {
                    id_task_type: formData.id_task_type,
                    internal_code: formData.internal_code,
                    id_machine: formData.id_machine,
                    interval: intervalValue,
                    description: formData.description,
                    supplies: formData.supplies
                });
            } else {
                let resultadoFinal = `TM_${inicialesMaquina.toUpperCase()}_${Date.now()}`;
                await insertTask({
                    id_task_type: formData.id_task_type,
                    internal_code: resultadoFinal,
                    id_machine: machine.Id_Machine,
                    interval: intervalValue,
                    description: formData.description,
                    supplies: formData.supplies
                });
            }
            dispatch(setData('Maquinas'));
            alert('Operación exitosa');
            dispatch(selectSubMenu('machineDetails'));
            dispatch(setData('Ordenes'));
            navigationHistory();
        } catch (error) {
            console.error(error);
        }
    };

    const handleBack = () => {
        navigationHistory();
    };

    return (
        <div className="InsertMachine-form-container">
            <form onSubmit={handleSubmit}>
                <label>
                    <strong >Tipo de Tarea: </strong>
                    <select name="id_task_type" value={formData.id_task_type} onChange={handleChange} required disabled={isEdit === false} hidden={formData.id_task_type === 6}>
                        <option value="">Selecciona un tipo de tarea</option>
                        {taskType
                            .filter(tipo => tipo.Name_Task_Type !== "Mantenimiento correctivo")
                            .map(tipo => (
                                <option key={tipo.Id_Task_Type} value={tipo.Id_Task_Type}>
                                    {tipo.Name_Task_Type}
                                </option>
                            ))}
                    </select>
                    {formData.id_task_type === 6 ? <p>Mantenimiento correctivo</p> : null}
                </label>
                <label >
                    <strong >Intervalo de la Tarea: </strong>
                    <input type="number" name="interval" value={formData.interval} onChange={handleChange} required min="1" disabled={isEdit === false}  hidden={formData.id_task_type === 6}/>
                    <select name="interval_unit" value={formData.interval_unit} onChange={handleChange} required disabled={isEdit === false}  hidden={formData.id_task_type === 6}>
                      <option value="">Selecciona una unidad</option>
                      <option value="dias">Días</option>
                      <option value="meses">Meses</option>
                      <option value="años">Años</option>
                    </select>
                    {formData.id_task_type === 6 ? (
                        <>
                        <p>No tiene una frecuencia fija, ya que se realiza </p>
                        <p>únicamente cuando ocurre un problema</p>
                        </>
                        ) : null}
                </label>
                <label>
                    <strong>Descripción de la Tarea: </strong>
                    <input type="text" name="description" value={formData.description} onChange={handleChange} required disabled={isEdit === false} />
                </label>
                <label>
                    <strong>Suministros Necesarios: </strong>
                    <input type="text" name="supplies" value={formData.supplies} onChange={handleChange} required disabled={isEdit === false} />
                </label>
                <div className="InsertMachine-button-container">
                    <button type="button" onClick={handleBack}>Regresar</button>
                    {isEdit !== false && <button type="submit">{isEdit ? "Actualizar Tarea" : "Insertar Tarea"}</button>}
                </div>
            </form>
        </div>
    );
};

export default InsertTask;
